(function () {
  "use strict";
  window.DeckauraToolTranslations = Object.assign(
    window.DeckauraToolTranslations || {},
    {
      "69 free tools · no sign-up": "69 kostenlose Tools · ohne Anmeldung",
      "Find my free tool": "Passendes kostenloses Tool finden",
      "Tarot · Astrology · Numerology · Compatibility":
        "Tarot · Astrologie · Numerologie · Kompatibilität",
      "guided tools": "geführte Tools",
      "clear categories": "klare Kategorien",
      "sign-ups required": "Anmeldungen erforderlich",
      "Free tools directory benefits": "Vorteile des kostenlosen Tool-Verzeichnisses",
      "One place to explore": "Alles an einem Ort entdecken",
      "Cards · Charts · Numbers · Matches":
        "Karten · Horoskope · Zahlen · Verbindungen",
      "Browse free tools": "Kostenlose Tools durchsuchen",
      "Search free tools": "Kostenlose Tools suchen",
      "Compatibility": "Kompatibilität",
      "Quizzes": "Tests",
      "Tarot & Card Readings": "Tarot- und Kartenlegungen",
      "Astrology & Birth Charts": "Astrologie und Geburtshoroskope",
      "Numerology & Numbers": "Numerologie und Zahlen",
      "Love & Compatibility": "Liebe und Kompatibilität",
      "Quizzes & Self-Discovery": "Tests und Selbsterkenntnis",
      "Open →": "Öffnen →",
      "Explore →": "Entdecken →",
      "Free Tarot Reading": "Kostenlose Tarotlegung",
      "A full guided three-card reading for any question.":
        "Eine vollständig geführte Drei-Karten-Legung für jede Frage.",
      "Yes or No Tarot": "Ja-oder-Nein-Tarot",
      "A clear yes, no or maybe straight from the cards.":
        "Eine klare Antwort: Ja, Nein oder Vielleicht – direkt aus den Karten.",
      "Love Tarot Reading": "Liebes-Tarotlegung",
      "A three-card spread focused on your love life.":
        "Eine Drei-Karten-Legung für Fragen rund um Liebe und Beziehung.",
      "Career Tarot Reading": "Berufs-Tarotlegung",
      "Three-card guidance shaped by your real work situation and question.":
        "Drei Karten, abgestimmt auf deine konkrete berufliche Situation und Frage.",
      "Weekly Zodiac Tarot": "Wöchentliches Sternzeichen-Tarot",
      "A consistent weekly theme, pressure point and response for your sun sign.":
        "Wochenthema, Herausforderung und Impuls passend zu deinem Sonnenzeichen.",
      "Tarot Timing Reading": "Tarot-Zeitdeutung",
      "Explore pace, conditions and what may change the timing.":
        "Erkenne Tempo, Bedingungen und Faktoren, die den Zeitpunkt verändern können.",
      "New Year Tarot Spread": "Neujahrs-Tarotlegung",
      "A five-card annual reflection for release, renewal and intention-setting.":
        "Fünf Karten für Rückblick, Loslassen, Neubeginn und klare Intentionen.",
      "Daily Tarot Card": "Tarot-Tageskarte",
      "Your card of the day, refreshed every morning.":
        "Deine Tageskarte – jeden Morgen neu.",
      "Random Tarot Card": "Zufällige Tarotkarte",
      "Pull a single card with its full meaning.":
        "Ziehe eine Karte und entdecke ihre vollständige Bedeutung.",
      "Celtic Cross Reading": "Keltisches-Kreuz-Legung",
      "Draw the full 10 card Celtic Cross spread.":
        "Ziehe die vollständige Keltische-Kreuz-Legung mit zehn Karten.",
      "7 Card Tarot Reading": "7-Karten-Tarotlegung",
      "A seven card horseshoe reading for any question.":
        "Eine Hufeisenlegung mit sieben Karten für jede Frage.",
      "Tarot Card Combinations": "Tarotkarten-Kombinationen",
      "See what any two tarot cards mean together.":
        "Entdecke, was zwei Tarotkarten gemeinsam bedeuten.",
      "Tarot Birth Card": "Tarot-Geburtskarte",
      "Find your birth-card sequence and current tarot year card.":
        "Finde deine Geburtskarten und deine aktuelle Tarot-Jahreskarte.",
      "Rune Reading": "Runenlegung",
      "Cast the Elder Futhark runes for guidance.":
        "Wirf die Runen des Älteren Futhark und erhalte einen klaren Impuls.",
      "Luminous Roots Oracle": "Luminous-Roots-Orakel",
      "Draw from an affirmation oracle deck.":
        "Ziehe eine Karte aus dem Affirmations-Orakeldeck.",
      "Tarot Spreads Guide": "Ratgeber zu Tarot-Legesystemen",
      "Learn the best spreads for every question.":
        "Finde das passende Legesystem für jede Frage.",
      "Tarot Questions": "Fragen an Tarotkarten",
      "120+ questions to ask the cards.":
        "Über 120 sinnvoll formulierte Fragen an die Karten.",
      "Birth Chart Calculator": "Geburtshoroskop-Rechner",
      "Explore estimated planetary signs and elemental balance; no houses.":
        "Ermittle Planetenkonstellationen und Elementeverteilung; ohne Häuserberechnung.",
      "Sun, Moon and Rising": "Sonne, Mond und Aszendent",
      "Calculate only your Big Three snapshot.":
        "Berechne Sonne, Mond und Aszendent auf einen Blick.",
      "Venus Sign Calculator": "Venuszeichen-Rechner",
      "Find the Venus sign that describes your love style.":
        "Finde das Venuszeichen, das deinen Liebesstil beschreibt.",
      "Chinese Zodiac Calculator": "Rechner für chinesische Sternzeichen",
      "Find your Chinese zodiac animal from your birth year.":
        "Finde dein chinesisches Tierkreiszeichen anhand deines Geburtsjahres.",
      "Daily Horoscope": "Tageshoroskop",
      "Today’s forecast for all twelve signs.":
        "Die heutige Deutung für alle zwölf Sternzeichen.",
      "Zodiac Sign Dates": "Sternzeichen und Daten",
      "Look up any zodiac sign by date.":
        "Bestimme das Sternzeichen anhand eines Datums.",
      "Saturn Return Calculator": "Saturn-Return-Rechner",
      "Estimate your Saturn Return windows.":
        "Berechne die Zeitfenster deiner Saturn-Wiederkehr.",
      "Human Design Chart": "Human-Design-Chart",
      "Generate your BodyGraph, Type, Strategy and Authority.":
        "Erstelle deinen BodyGraph mit Typ, Strategie und Autorität.",
      "Moon Phase Today": "Heutige Mondphase",
      "The current moon phase and what it means.":
        "Die aktuelle Mondphase und ihre Bedeutung.",
      "Vedic Astrology Chart": "Vedisches Geburtshoroskop",
      "Your sidereal (Jyotish) birth chart.":
        "Dein siderisches Geburtshoroskop nach Jyotish.",
      "Mayan Astrology": "Maya-Astrologie",
      "Discover your Mayan day sign.": "Entdecke dein Maya-Tageszeichen.",
      "Black Moon Lilith": "Schwarzer Mond Lilith",
      "Estimate your Lilith sign from one birth date.":
        "Bestimme dein Lilith-Zeichen anhand deines Geburtsdatums.",
      "Lilith Sign, Degree and House": "Lilith-Zeichen, Grad und Haus",
      "Use birth time and city for precise placement.":
        "Nutze Geburtszeit und -ort für eine präzise Position.",
      "Lunar Nodes": "Mondknoten",
      "Your North and South Node placements.":
        "Deine Positionen des Nord- und Südknotens.",
      "Numerology Compatibility": "Numerologische Kompatibilität",
      "Compare two Life Path patterns from two birthdays.":
        "Vergleiche die Lebenszahl-Muster zweier Geburtsdaten.",
      "Life Path Number Calculator": "Lebenszahl-Rechner",
      "Calculate one Life Path with every reduction step.":
        "Berechne deine Lebenszahl mit allen Rechenschritten.",
      "Angel Number by Birthday": "Persönliche Engelszahl",
      "Calculate your personal number from your birth date.":
        "Berechne deine persönliche Zahl aus deinem Geburtsdatum.",
      "Angel Number Meanings": "Engelszahlen-Bedeutungen",
      "Look up a repeating number you keep seeing.":
        "Finde die Bedeutung einer Zahl, die dir immer wieder begegnet.",
      "Biorhythm Calculator": "Biorhythmus-Rechner",
      "Track one person’s physical, emotional and mental cycles.":
        "Verfolge körperliche, emotionale und geistige Zyklen einer Person.",
      "Synastry Chart Comparison": "Synastrie-Vergleich",
      "Compare two Big Three snapshots for relationship patterns.":
        "Vergleiche Sonne, Mond und Aszendent zweier Personen.",
      "Zodiac Compatibility": "Sternzeichen-Kompatibilität",
      "Compare two Sun signs across four relationship dimensions.":
        "Vergleiche zwei Sonnenzeichen in vier Beziehungsbereichen.",
      "Twin Flame Calculator": "Dualseelen-Rechner",
      "Explore mirror, soulmate and growth patterns.":
        "Erkenne Spiegel-, Seelenpartner- und Wachstumsmuster.",
      "Biorhythm Compatibility": "Biorhythmus-Kompatibilität",
      "Compare two people’s biorhythm cycles.":
        "Vergleiche die Biorhythmus-Zyklen zweier Personen.",
      "Spirit Animal Quiz": "Krafttier-Test",
      "Discover your spirit animal and its message.":
        "Entdecke dein Krafttier und seine Botschaft.",
      "What Tarot Card Am I? Quiz": "Welche Tarotkarte bin ich?",
      "Match your answers to a Major Arcana archetype.":
        "Finde den Archetyp der Großen Arkana, der zu deinen Antworten passt.",
      "When an instant result is not enough":
        "Wenn ein Sofortergebnis nicht ausreicht",
      "A reading shaped around your question":
        "Eine Deutung, die auf deine Frage zugeschnitten ist",
      "Start with a free tool, then tell us what is actually happening. Your supplied result, question and context are connected into one private reading in Deckaura’s warm Selin editorial voice.":
        "Starte mit einem kostenlosen Tool und beschreibe anschließend, was dich wirklich beschäftigt. Dein Ergebnis, deine Frage und dein Kontext fließen in eine persönliche, vertrauliche Deutung im warmen Deckaura-Selin-Stil ein.",
      "Personalized reading service details":
        "Details zur persönlichen Deutung",
      "Your question is required": "Eine konkrete Frage ist erforderlich",
      "Grounded in your exact result": "Auf dein konkretes Ergebnis abgestimmt",
      "Ready in about 90 minutes": "In etwa 90 Minuten fertig",
      "Reading depth options": "Umfang der Deutung",
      "Essential": "Kompakt",
      "Deeper": "Vertieft",
      "In-Depth": "Ausführlich",
      "Most chosen": "Am häufigsten gewählt",
      "A focused 450+ word reading for one clear question.":
        "Eine fokussierte Deutung mit mindestens 450 Wörtern zu einer klaren Frage.",
      "A 750+ word analysis connecting the central pattern, tension and practical options.":
        "Eine Analyse mit mindestens 750 Wörtern zu Muster, Spannungsfeld und konkreten Möglichkeiten.",
      "A 1,250+ word reading with decision paths, tradeoffs and a grounded 30-day reflection plan.":
        "Eine ausführliche Deutung mit mindestens 1.250 Wörtern, Entscheidungswegen und einem realistischen 30-Tage-Reflexionsplan.",
      "Or choose the exact kind of guidance you need":
        "Oder wähle genau die Art von Deutung, die du brauchst",
      "Every page now asks for the information its method actually needs.":
        "Jede Seite fragt nur die Angaben ab, die für ihre Methode wirklich nötig sind.",
      "Tarot, Oracle & Runes": "Tarot, Orakel und Runen",
      "Numbers & Personal Cycles": "Zahlen und persönliche Zyklen",
      "Self-Discovery": "Selbsterkenntnis",
      "Apply an exact three-card spread to your relationship question.":
        "Wende eine konkrete Drei-Karten-Legung auf deine Beziehungsfrage an.",
      "Connect your Luminous Roots draw to the situation behind it.":
        "Verbinde deine Luminous-Roots-Karte mit der Situation dahinter.",
      "Interpret an exact Elder Futhark cast in your real context.":
        "Deute einen konkreten Wurf des Älteren Futhark in deinem persönlichen Kontext.",
      "Explore your Personality, Soul and current Year cards.":
        "Entdecke deine Persönlichkeits-, Seelen- und aktuelle Jahreskarte.",
      "Read two exact cards together as one ordered pattern.":
        "Lies zwei konkrete Karten gemeinsam als zusammenhängendes Muster.",
      "Apply your Major Arcana quiz result to life now.":
        "Übertrage das Ergebnis deines Große-Arkana-Tests auf deine aktuelle Lebenssituation.",
      "Connect your Sun, Moon and Rising signs without inventing placements.":
        "Verbinde Sonne, Mond und Aszendent, ohne Positionen zu erfinden.",
      "Interpret the chart snapshot and elemental balance you provide.":
        "Deute dein Horoskop und die angegebene Elementeverteilung.",
      "Explore an exact Lilith sign, degree or house in context.":
        "Deute dein konkretes Lilith-Zeichen, den Grad oder das Haus im Zusammenhang.",
      "Reflect on your supplied North and South Node placements.":
        "Betrachte deine angegebenen Nord- und Südknoten-Positionen.",
      "Apply your calculated Mayan day sign to a current theme.":
        "Beziehe dein berechnetes Maya-Tageszeichen auf ein aktuelles Thema.",
      "Explore your calculated Moon sign and emotional pattern.":
        "Erkunde dein berechnetes Mondzeichen und dein emotionales Muster.",
      "A focused forecast grounded in your sign or chart signals.":
        "Eine fokussierte Vorschau auf Grundlage deines Zeichens oder Horoskops.",
      "Navigate your calculated Saturn Return window and transition.":
        "Ordne dein berechnetes Saturn-Return-Zeitfenster und den Übergang ein.",
      "Interpret the sidereal placements from your Jyotish chart.":
        "Deute die siderischen Positionen deines Jyotish-Horoskops.",
      "Explore the repeating number, context and pattern you provide.":
        "Deute die wiederkehrende Zahl im von dir beschriebenen Kontext.",
      "Apply exact physical, emotional and intellectual cycle levels.":
        "Beziehe deine genauen körperlichen, emotionalen und geistigen Zykluswerte ein.",
      "Connect your calculated Life Path to one current question.":
        "Verbinde deine berechnete Lebenszahl mit einer aktuellen Frage.",
      "Compare two exact cycle results in the relationship context.":
        "Vergleiche zwei konkrete Zyklusergebnisse im Beziehungskontext.",
      "Explore two supplied Big Three snapshots without mind-reading.":
        "Vergleiche zwei angegebene Big-Three-Profile ohne unbelegte Annahmen.",
      "Reflect on the match result, boundaries and growth themes.":
        "Betrachte Ergebnis, Grenzen und Wachstumsthemen der Verbindung.",
      "Apply all five compatibility scores to your real dynamic.":
        "Übertrage alle fünf Kompatibilitätswerte auf eure tatsächliche Dynamik.",
      "Connect your Type, Strategy, Authority and Profile to a decision.":
        "Verbinde Typ, Strategie, Autorität und Profil mit deiner Entscheidung.",
      "Apply your quiz archetype to a current strength or challenge.":
        "Beziehe deinen Test-Archetyp auf eine aktuelle Stärke oder Herausforderung.",
      "Your result is not treated like a prediction.":
        "Dein Ergebnis wird nicht als feste Vorhersage behandelt.",
      "It becomes evidence for a grounded, reflective reading with clear limits and practical next steps.":
        "Es dient als Grundlage für eine realistische, reflektierte Deutung mit klaren Grenzen und praktischen nächsten Schritten.",
      "Selin’s method is ready for your question":
        "Selins Methode ist bereit für deine Frage",
      "Featured Decks & Guides": "Empfohlene Decks und Ratgeber",
      "Free Resources, Widgets & Research":
        "Kostenlose Ressourcen, Widgets und Forschung",
      "Need help with an order? Read our":
        "Brauchst du Hilfe zu einer Bestellung? Lies unsere",
      "Cancellation Policy": "Stornierungsbedingungen",
      "Want guidance written just for you?":
        "Möchtest du eine Deutung, die nur für dich geschrieben ist?",
      "Every tool gives you a free result. When you want the deep version, choose the life area or question that matters and receive a personalized reading connecting the result to that exact context.":
        "Jedes Tool liefert dir ein kostenloses Ergebnis. Wenn du tiefer gehen möchtest, wähle den passenden Lebensbereich oder deine konkrete Frage und erhalte eine persönliche Deutung, die genau diesen Kontext einbezieht.",
      "Start with a Free Tarot Reading →":
        "Mit einer kostenlosen Tarotlegung starten →",
      "Your full reading is written by hand around your cards and exact question, with a clear answer and guidance you can use. 100% digital, yours to keep.":
        "Deine ausführliche Deutung wird zu deinen Karten und deiner konkreten Frage von Hand geschrieben – mit einer klaren Antwort und praktischen Impulsen. 100 % digital und dauerhaft für dich verfügbar.",
      "Your three-card reading": "Deine Drei-Karten-Legung",
      "Nothing ships.": "Kein Postversand.",
      "nothing ships.": "kein Postversand.",
      "Digital delivery by email in about 90 minutes; nothing ships.":
        "Digitale Zustellung per E-Mail in etwa 90 Minuten; kein Postversand.",
      "✨ Browse All Free Tools": "✨ Alle kostenlosen Tools entdecken",
      "🔮 Ask the Cards a Question": "🔮 Stelle den Karten eine Frage",
      "Choose the Tarot Tool That Matches Your Intent":
        "Wähle das Tarot-Tool, das zu deiner Absicht passt",
      "Comparing your answer pattern across all 22 Major Arcana...":
        "Dein Antwortmuster wird mit allen 22 Karten der Großen Arkana verglichen …",
      "Get a Reading": "Deutung erhalten",
      "Start the 10-question quiz": "Test mit 10 Fragen starten",
      "Your five-card New Year spread": "Deine Neujahrslegung mit fünf Karten",
      "0/240 · Ask about the energy, choices or lesson you can work with.":
        "0/240 · Frage nach einer Energie, Entscheidung oder Lektion, mit der du arbeiten kannst.",
      "0/240 · Leave blank for a focused sign-and-week reading.":
        "0/240 · Für eine allgemeine Wochenlegung zu deinem Zeichen leer lassen.",
      "Your question": "Deine Frage",
      "Reading the energy now…": "Die aktuelle Energie wird gedeutet …",
      "We're here to help.": "Wir helfen dir gern.",
      "Questions about a personalized reading, an order, or one of our free tarot and astrology tools? Send us a message below or email hello@deckaura.com. We usually reply within one business day.":
        "Hast du Fragen zu einer persönlichen Deutung, einer Bestellung oder einem unserer kostenlosen Tarot- und Astrologie-Tools? Sende uns unten eine Nachricht oder schreibe an hello@deckaura.com. Wir antworten normalerweise innerhalb eines Werktags.",
      "Free Forever · No Signup": "Dauerhaft kostenlos · ohne Anmeldung",
      "A free tarot widget for bloggers, readers, and spiritual sites":
        "Ein kostenloses Tarot-Widget für Blogs, Kartenleger und spirituelle Websites",
      "Free to use on personal and commercial sites":
        "Kostenlos für private und kommerzielle Websites",
      "Give your visitors a tarot card to draw every day. They tap to reveal its upright, reversed, love and yes/no meaning. Copy one snippet and paste it anywhere.":
        "Lass deine Besucher täglich eine Tarotkarte ziehen. Mit einem Fingertipp sehen sie die aufrechte und umgekehrte Bedeutung sowie Hinweise zu Liebe und Ja/Nein. Kopiere einfach einen Code-Schnipsel und füge ihn an beliebiger Stelle ein.",
      "Paste it into any page, blog post, or sidebar (HTML / custom code block). The widget appears right where you place the code, responsive and works everywhere.":
        "Füge den Code in eine Seite, einen Blogbeitrag oder eine Seitenleiste ein. Das responsive Widget erscheint genau dort, wo du es platzierst.",
      "There is nothing to install and no account to create. The widget is hosted by Deckaura, so once you paste the code you never have to touch it again.":
        "Es ist keine Installation und kein Konto nötig. Das Widget wird von Deckaura gehostet; nach dem Einfügen musst du nichts mehr pflegen.",
      "Want the full reading?": "Möchtest du die vollständige Deutung?",
      "The clear answer.": "Die klare Antwort.",
      "Ask the Cards a Question": "Stelle den Karten eine Frage",
      "Reduce each part to a single digit, then add them and reduce one last time. The one rule that trips people up is the master numbers, 11, 22, and 33, which are never reduced.":
        "Reduziere jeden Teil auf eine Ziffer, addiere die Ergebnisse und reduziere die Summe ein letztes Mal. Die Ausnahme sind die Meisterzahlen 11, 22 und 33; sie werden nicht weiter reduziert.",
      "It does not replace Deckaura’s Daily Tarot Card, Yes or No Tarot, or multi-card free tarot reading. That separation gives each tool one clear purpose.":
        "Es ersetzt weder Deckauras Tageskarte noch das Ja-oder-Nein-Tarot oder eine kostenlose Legung mit mehreren Karten. So behält jedes Tool einen klaren Zweck.",
      "You can also learn about each card in our complete Tarot Card Meanings guide or learn how to read tarot cards.":
        "Mehr über jede Karte erfährst du in unserem vollständigen Ratgeber zu Tarotkarten-Bedeutungen oder in der Anleitung zum Kartenlesen.",
      "Treat the result as a conversation prompt, not evidence about the relationship.":
        "Nutze das Ergebnis als Gesprächsimpuls, nicht als Beweis über eure Beziehung.",
      "🃏All the MeaningsUpright, reversed, love, and a clear yes/no answer for every card drawn.":
        "🃏Alle BedeutungenAufrecht, umgekehrt, Liebe und eine klare Ja-/Nein-Antwort zu jeder gezogenen Karte.",
      "Try a complete Free Tarot Reading, look up all 78 Tarot Card Meanings, find your Tarot Birth Card or get an instant yes or no tarot answer, all free at Deckaura.":
        "Probiere eine vollständige kostenlose Tarotlegung, entdecke alle 78 Tarotkarten-Bedeutungen, finde deine Tarot-Geburtskarte oder erhalte sofort eine Ja-/Nein-Antwort – alles kostenlos bei Deckaura.",
      "Nothing ships": "Kein Postversand",
      "Questions about a personalized reading, an order, or one of our free tarot and astrology tools? Send us a message below or email":
        "Hast du Fragen zu einer persönlichen Deutung, einer Bestellung oder einem unserer kostenlosen Tarot- und Astrologie-Tools? Sende uns unten eine Nachricht oder schreibe an",
      "We usually reply within one business day.": "Wir antworten normalerweise innerhalb eines Werktags."
    },
  );
})();
